import { InternalTransferAddTransactionDetailModelDto, ModelBaseDto } from '@treasury/api/channel';
import { mapFrequencyToFrequencyModelDto } from '@treasury/presentation/components/tm-frequency.mappings';
import { OneTimeTodayFrequency } from '@treasury/presentation/components/tm-frequency.types';
import { format } from 'date-fns';
import { TransferAccount } from '.';
import { DomainEntity } from '../shared/types';

type TransactionDto = Omit<InternalTransferAddTransactionDetailModelDto, keyof ModelBaseDto>;

export class Transaction extends DomainEntity<TransactionDto> {
    constructor(dto: TransactionDto = {}) {
        super(dto);
        this.fromAccount = dto.fromAccount ? new TransferAccount(dto.fromAccount) : undefined;
        this.toAccount = dto.toAccount ? new TransferAccount(dto.toAccount) : undefined;
        this.frequency = dto.frequency || mapFrequencyToFrequencyModelDto(OneTimeTodayFrequency);
        this.transferDate = dto.transferDate || format(new Date(), 'P');
    }

    public fromAccount?: TransferAccount;

    public toAccount?: TransferAccount;

    public createDefault() {
        return new Transaction() as this;
    }

    public get transactionId() {
        return this.dto.transactionId;
    }

    public get status() {
        return this.dto.status;
    }

    public set status(status: string | undefined) {
        this.dto.status = status;
    }

    public get amount() {
        return this.dto.amount;
    }

    public set amount(amount) {
        this.dto.amount = amount;
    }

    public get transferDate() {
        return this.dto.transferDate;
    }

    public set transferDate(transferDate) {
        this.dto.transferDate = transferDate;
    }

    public get frequency() {
        return this.dto.frequency;
    }

    public set frequency(frequency) {
        this.dto.frequency = frequency;
    }

    public get memo() {
        return this.dto.memo;
    }

    public set memo(memo) {
        this.dto.memo = memo;
    }

    public toDto() {
        return {
            ...this.dto,
            fromAccount: this.fromAccount?.toDto(),
            toAccount: this.toAccount?.toDto(),
        };
    }
}
